import DetailsViewCard from './DetailsViewCard';

export default DetailsViewCard;
